import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
:root {
  --gap: 32px;

  --primaryColor: #163979;
  --primaryColorDark: #0c244f;
  --secondaryColor: #1D863F;

  --infoColor: #27aeda;
  --infoColorLight: #f3fcff;
  --errorColor: #ff2e51;
  --errorColorDark: #a50f28;
  --errorColorLight: #FF8492;
  --errorColorLighter: #ce8483;
  --successColor: #1D863F;
  --successColorDark: #156f32;
  --warnColor: #ffbf2f;
  --warnColorDark: #b57d00;

  --secondaryInfoColor: #d1722f;
  --infoGrey: #6c757d;
  --greyDark: #707070;
  --grey: #B3B3B3;
  --greyLight: #eee;
  --greyLighter: #f5f5f5;
  --greyLightest: #f7f7f7;

  // Mainly webshop palette
  --blue: #233C78;
  --green: #1D863F;
  --lightBlue: #0099d4;
  --lighterBlue: #2D7BB4;
  --lightestBlue: #BFE5F4;
  --darkGrey: #5B5B5B;
  --detailGrey: #6E6E6E;
  --lightGrey: #767676;
  --lighterGrey: #848484;
  --red: #ED1C24;

  --darkBlue: #253c7e;
  --backgroundGrey: #E9EAEA;
  --textGrey: #313131;

  // Status colors
  --ordered: #eed24d; // Tilattu
  --approved: #eed24d; // Hyväksytty
  --assigned: #eed24d; // Varattu
  --acknowledged: #fd954a; // Kuitattu -> Käsitellään
  --in-progress: #6cd1fb; // Käynnissä
  --delivered: #7DE0DA; // Kuljetettu -> Saapunut
  --canceled: #bababa; // Peruttu
  --delegated: #80D08D; // Välitetty
  --completed: #80D08D; // Valmis
  --failed: #bababa; // Epäonnistunut
}

h1, h2, h3, h4, h5, h6 {
  color: var(--primaryColor);
}

h4, h5, h6 {
  font-weight: 400;
}

a {
  text-decoration: none;

  &:hover {
    color: inherit;
  }
}

p {
  line-height: 26px;
  font-size: 16px;
  color: var(--blue);
}

button {
  background: none;
  border: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: 0;
  margin: 0;
}

[role="button"] {
  position: relative;
}

[role="button"]:hover {
  cursor: pointer;
}

[role="button"]:focus {
  outline: none;
}

[role="button"]:focus::before {
  position: absolute;
  z-index: 1; // Not sure about this

  /* button border width - outline width - offset */
  top: calc(-1px - 3px - 3px);
  right: calc(-1px - 3px - 3px);
  bottom: calc(-1px - 3px - 3px);
  left: calc(-1px - 3px - 3px);
  border: 3px solid hsl(213deg 71% 49%);

  /* button border radius + outline width + offset */
  border-radius: calc(5px + 3px + 3px);
  content: "";
}

:root {
  --field-width: 524px;
  --field-width-wide: 822px;
}


// Fix weird Bootstrap 5 default
@media (min-width: 1200px){
  .container {
    max-width: 1100px;
  }
}

// Tippy tooltips
#tooltip[data-placement^='top'] > #arrow {
  bottom: -4px;
}

#tooltip[data-placement^='bottom'] > #arrow {
  top: -4px;
}

#tooltip[data-placement^='left'] > #arrow {
  right: -4px;
}

#tooltip[data-placement^='right'] > #arrow {
  left: -4px;
}

#arrow,
#arrow::before {
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: white;
  border-right: 1px solid var(--infoGrey);
  border-bottom: 1px solid var(--infoGrey);
  z-index: 9999999;
}

#arrow {
  visibility: hidden;
}

#arrow::before {
  visibility: visible;
  content: '';
  transform: rotate(45deg);
}
`;
